import * as React from 'react';
import { ICustomers, IDataCenter } from '../../../vm';
import { getAllDataCentersOfCustomer } from '../../../services/datacenter/DatacenterService';
import { Pivot, PivotItem } from 'office-ui-fabric-react';
import ReportApprovalStatus from './ReportApprovalStatus';

export interface CustomerReportMainProps {
  customerId: string;
  customer: ICustomers;
}

const CustomerReportMain: React.FC<CustomerReportMainProps> = ({
  customer,
  customerId,
}) => {
  // local state
  const [datacenters, setDatacenters] = React.useState([] as IDataCenter[]);
  const [isLoading, setLoading] = React.useState(false);
  const [selectedPivot, setPivot] = React.useState();

  React.useEffect(() => {
    getCustomerDataCenters();
    getCustomerReportStatus();
  }, []);

  const getCustomerDataCenters = async () => {
    const result = await getAllDataCentersOfCustomer(customerId);
    if (result?.success === true) {
      setDatacenters(result.data);
    } else {
    }
  };

  const getCustomerReportStatus = async () => {
    // todo customer report status
  };

  const handleCallToRouter = (value: any) => {
    setPivot(value.props.itemKey);
    // history.push(window.location.pathname + '#' + value.props.itemKey);
  };
  const _getTabId = (itemKey: string): string => {
    return `${itemKey}`;
  };
  return (
    <React.Fragment>
      <Pivot
        onLinkClick={handleCallToRouter}
        defaultSelectedKey={selectedPivot}
        selectedKey={selectedPivot}
        getTabId={_getTabId}>
        {datacenters.map((d) => {
          return (
            <PivotItem itemKey={d._id} headerText={`${d.location}`}>
              <ReportApprovalStatus
                customerId={customerId}
                customer={customer}
                datacenterId={d._id as string}
                datacenter={d}
                datacenters={datacenters}
              />
            </PivotItem>
          );
        })}
      </Pivot>
    </React.Fragment>
  );
};

export default CustomerReportMain;
